import getPeoplePath from 'owa-url/lib/getPeoplePath';
import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { importContact } from '../actions/importContact';

orchestrator(importContact, () => {
    window.open(getPeoplePath() + 'import');
    completeGetStartedTask(GetStartedTaskId.ImportContact);
});
